import twLocale from 'element-ui/lib/locale/lang/zh-TW' //引入element语言包
const tw = {
  LoginPage: {
    text1: '登入您的帳戶',
    text2: '郵箱/手機號',
    text3: '輸入圖形碼',
    text4: '密碼',
    text5: '忘記密碼？ ',
    text6: '登入',
    text7: '我已同意並閱讀',
    text8: '和',
    text9: '《用戶協議》',
    text10: '《隱私政策》',
    text11: '或者',
    text12: '注册帳戶',
    text13: '提示',
    text14: '閱讀並同意',
    text15: '取消',
    text16: '同意',
    text17: '注册成功',
    text18: '登入成功',
    text19: '請輸入有效的郵箱/手機號',
    text20: '帳號密碼錯誤',
    text21: '請輸入密碼',
    text22: '密碼長度不能少於8比特',
    text23: '密碼必須包含字母和數位',
    text24: '密碼不一致',
  },
  RegisterPage: {
    text1: '注册',
    text2: '郵箱/手機號',
    text3: '發送驗證碼',
    text4: '密碼',
    text5: '再次確認密碼',
    text6: '至少8位數，字母和數位組成',
    error1: '請輸入有效的郵箱/手機號',
    error2: '請輸入驗證碼',
    error3: '帳號密碼錯誤',
    text7: '驗證碼'
  },
  ResetPassword: {
    text1: '重置密碼',
    text2: '再次確認密碼',
    text3: '至少8位數，字母和數位組成',
    text4: '確認',
    text5: '重置成功',
  },
  ForgotPassword: {
    text1: '找回密碼',
    text2: '郵箱/手機號',
    text3: '發送驗證碼',
    text4: '下一步',
    text5: '後重新發送',
    text6: '請輸入有效的驗證碼',
  },
  HomePage: {
    headerText1: '首頁',
    headerText2: '文字翻譯',
    headerText3: '語音翻譯',
    headerText4: 'AI智慧體',
    headerText5: '資源',
    buttonText1: '登入',
    buttonText2: '免費試用',
    langText1: '中文（繁體）',
    langText2: '中文（簡體）',
    langText3: 'English（英語）',
    resources1: 'API檔案',
    resources2: '探索我們的API檔案',
    resources3: '常見問題',
    resources4: '問題和解決方案',
    resources5: '聯繫我們',
    resources6: '詳細諮詢詳情',
    scheme1: '請選擇合適的方案',
    scheme2: '超低價格·多語言支持·方案定制，聯系客服',
    scheme3: '文字翻譯',
    scheme4: '語音翻譯',
    scheme5: '檔案翻譯',
    scheme6: '基礎版',
    scheme7: '/百萬字元',
    scheme8: '併發（qps）',
    scheme9: '5～1000（支持擴展）',
    scheme10: '百度翻譯-企業版本',
    scheme11: '有道翻譯',
    scheme12: '火山翻譯',
    scheme13: 'yandex',
    scheme14: '瞭解詳情',
    scheme15: '高級版',
    scheme16: 'DeepL- API PRO',
    scheme17: '穀歌翻譯- V2/V3',
    scheme18: '微軟翻譯',
    scheme19: '標準版',
    scheme20: 'ChatGPT翻譯',
    scheme21: '語音轉文字識別',
    scheme22: '/小時',
    scheme23: '100(支持擴展)',
    scheme24: '指定語言語音翻譯',
    scheme25: '自動識別語言語音翻譯',
    scheme26: 'DeepL翻譯',
    num1: 25,
    num2: 60,
    num3: 50,
    num4: 3.6,
    num5: 9.1,
    num6: 10.2,
    num7: 90,
    num8: 5,
    fanyi1: '連接頂尖翻譯引擎，匹配您的場景需求',
    fanyi2: '無論是商務檔案、跨境電商還是科技當地語系化，我們都能為您精准調度最優翻譯資源，實現高效、安全、低成本的全球化溝通。 ',
    fanyi3: '文字翻譯',
    fanyi4: '語音翻譯',
    fanyi5: '語音辨識',
    fanyi6: 'AI實时翻譯，提供多元化方案',
    fanyi7: '140+語言方言·400+高品質音色·隨心選擇（介面免費試用）',
    intelligent1: 'AI智慧體：您的數字世界超級助手',
    intelligent2: '支持語音、文字的多元溝通，能提供實时對話機器人、寫作助手以及學習助手等功能，可以回答科學、科技、歷史、文化、娛樂等各種領域的問題',
    intelligent3: '智能助手',
    intelligent4: '語音對話',
    support1: '選擇我們的優勢',
    support2: '認證技術支援',
    support3: '我們的資深AI語音技術團隊提供微軟TTS/STT全棧解決方案，讓企業級語音互動高效落地，釋放智慧語音的商業價值！ ',
    support4: '綜合代理服務商',
    support5: '聚合多家頭部科技服務商，提供最優科技組合方案，多元化的資源整合能力和專業服務，能為企業客戶創造顯著價值',
    support6: '優勢通路價格',
    support7: '我們是主流翻譯引擎綜合代理服務商，彙集眾多企業客戶，我們可提供優勢通路價格',
    footer1: '預約您的專屬解決方案顧問，獲取定制化報價方案',
    footer2: '請輸入您的姓名',
    footer3: '請輸入您的電話',
    footer4: '預約',
    footer5: '預約成功，請留意您的來電資訊',
    footer6: '關於我們：',
    footer7: 'XRION TECHNOLOGY LIMITED',
    footer8: '郵箱：admin@xrion.ai',
    footer9: '香港手機號: +852 4640 4336',
    footer10: '翻譯',
    footer11: 'AI大模型',
    footer12: '資源',
    footer13: '文字翻譯',
    footer14: 'AI智慧體',
    footer15: 'API檔案',
    footer16: '語音翻譯',
    footer17: '常見問題',
    footer18: '港ICP備8384773838282號-1',
    expect: '敬請期待',
    text1: '香港手機號',
    text2: 'AI庫下載',
    text3: '使用者協定',
    text4: '隱私政策',
    text5: '付費協定',
    text6: '返回',
    text7:'原價：'
  },
  TextTranslation: {
    text1: '控制台',
    text2: '登出',
    text3: '自動檢測',
    text4: '輸入文字，自動翻譯. ..',
    text5: '語言蒐索',
    text6: '檢測語言',
    text7: '蒐索語言',
    text8: '請選擇目標語言',
    text9: '請先登錄',
  },
  VoicePage: {
    text1: '語音翻譯',
    text2: '語音辨識',
    text3: '定向翻譯',
    text4: '僅顯示翻譯目標語言',
    text5: '雙向翻譯',
    text6: '自動識別雙語言翻譯',
    text7: '錄入語言：',
    text8: '識別結果（單次識別最長支持1分鐘）',
    text9: '翻譯餘額不足，請先充值',
    text10: '取消',
    text11: '去充值',
    text12: '中文（普通話，簡體）',
    text13: '英文（美國）',
    text14: '這裡顯示目標語言翻譯結果...',
    text15: '這裡顯示語音辨識結果...'
  },
  ConsolePanel: {
    text1: '翻譯金鑰',
    text2: '複製',
    text3: '查看API金鑰',
    text4: '充值',
    text5: '提示：1.如有使用問題或需發票協助，請聯系客服',
    text6: '使用統計圖',
    text7: '近7天',
    text8: '近15天',
    text9: '近30天',
    text10: '複製成功',
    text11: '使用詳情',
    text12: "操作",
    text13: "翻譯引擎",
    text14: "價格（百萬字元）",
    text15: "已使用字元數",
    text16: "剩餘字元數",
    text17: "查看API公開金鑰",
    text18: "字元",
    text19: "2.匯率每日更新，實際支付金額可能因匯率波動略有調整",
    text20: "貨幣:",
    text21: "DeepL",
    text22: "穀歌翻譯",
    text23: "微軟翻譯",
    text24: "百度翻譯-企業版本",
    text25: "有道翻譯",
    text26: "火山翻譯",
    text27: "chatGPT翻譯",
    text28: "yandex",
    text29:'服務類型',
    text30:'原價（小時）',
    text31:'限時優惠價（小時）',
    text32:'已消耗時長',
    text33:'已消耗費用',
    text34:'剩餘金額',
    text35:'語音轉文字識別',
    text36:'指定語言語音翻譯',
    text37:'自動識別語言語音翻譯',    
    text38:'原價（百萬字元）',
    text39:'優惠價（元/百萬字元）',
    text40:'RMB',
    text41:'USD',
    text42:'費用'
  },
  PayPage: {
    text1: '充值訂單',
    text2: '服務資訊',
    text3: '用戶ID',
    text4: '充值產品',
    text5: '翻譯引擎',
    text6: '充值字元數量',
    text7: '百萬',
    text8: '價格',
    text9: '/百萬字元',
    text10: '合計',
    text11: '支付方式',
    text12: '已閱讀並同意',
    text13: '《XRION服務付費協議》',
    text14: '支付',
    text15: '翻譯字元數量不足，請先充值',
    text16: '提交訂單',
    text17: '確定支付',
    text18: '支付成功',
    text19: '支付失敗',
    text20: '微信支付',
    text21: '支付寶',
    text22: '餘額',
    text23: '充值金額',
    text24:'$'
  },
  OrderPage:{
    Text1:'支付金額：',
    Text2:'請在倒數計時',
    Text3:'分鐘',
    Text4:'秒',
    Text5:'前完成支付，否則訂單將自動取消',
    Text6:'打開手機支付寶',
    Text7:'打開手機微信',
    Text8:'掃一掃繼續支付',
    Text9:'已超時',
    Text10:'訂單已超時，請返回控制台重新提交訂單',
    Text11:'支付成功',
    Text12:'支付超時',
    Text13:'離開代表您放弃支付該訂單，確認離開嗎',
    Text14:'您還未支付成功，請勿離開當前介面！ ',
    Text15:'確定',
    Text16:'取消',
  },
  StripePay: {
    text1: '訂單提交成功，支付訂單號：',
    text2: '訂單資訊：',
    text3: '百萬字元',
    text4: '支付金額：',
    text5: '語音翻譯餘額充值'
  },
  PayResult: {
    text1: '返回控制台',
  },
  IntelligentAgent: {
    Text1: '蒐索歷史記錄',
    Text2: '删除',
    Text3: 'Hi！ 我是您的智能助手',
    Text4: '輸入您的迴響和建議～',
    Text5: '提交',
    Text6: '輸入您的問題. ..',
    Text7: '删除對話',
    Text8: '删除後，該對話不可恢復。 確認删除嗎？ ',
    Text9: '取消',
    Text10: '收起側邊欄',
    Text11: '展開',
  },
  FAQPage: {
    Title:"常見問題",
    Question1: 'Q1.XRION是如何服務客戶的？ ',
    Text1: '我們是一個聚合翻譯服務商，聚合主流的翻譯公司介面，提供更便宜、多樣化的翻譯服務。 ',
    Question2: 'Q2.當前提供哪些翻譯引擎？ ',
    Text2: 'DeepL、 穀歌、百度、有道翻譯、微軟、火山翻譯、 OpenAI、YanDex。 ',
    Question3: 'Q3.翻譯字元是如何計費的？ ',
    Text3: '按字元數計算您的使用量。 計算的字元是源文字中的字元數，即您要翻譯的原文。 一個字元對應於一個UTF-8編碼後的程式碼點，即一個漢字或者英文字母都算一個字元。 翻譯的字元數與所使用的翻譯服務對應的計費倍率相乘後取整得到最終的計費字元數。 ',
    Question4: 'Q4.是否可以開啟增值稅發票？ ',
    Text4: '可以。 聯系客服即可開取增值稅發票，如需開票，需提前預約。 ',
    Question5: 'Q5.是否會存儲我的翻譯請求？ ',
    Text5: '不存儲任何您請求的文字或其翻譯結果。 只有關於請求的中繼資料（請求的時間和翻譯的字元數）會被保存用於計費和統計的目的。 ',
    Question6: 'Q6.我的翻譯源文字和翻譯結果是否會有洩漏風險？ ',
    Text6: '絕不存儲您的翻譯源文字和翻譯結果，然而我們無法保證上游服務的數據儲存規則。 請在使用不同的服務的時候參攷對應服務的隱私條例來規避風險。 ',
  },
  errorMsg1: '現時識別中，請稍後...',
  ...twLocale //这里引入element语言包目的是在切换语言的时候，element的组件里面的文字能跟随切换
}
// 导出
export default tw;
